import React, { PureComponent } from 'react';

import moize from 'moize';


import _ from 'underscore';

import { translate } from 'react-i18next';

@translate(['common'])
class LineChart extends PureComponent {

    
    constructor(props){
        super()
        this.state = {
            chart: null,
            dateAxis: null,
            chartDisplay: 'normal',
            indicator:false
        }
    }



    shouldComponentUpdate(nextProps, nextState) {
        return JSON.stringify(nextProps.data) != JSON.stringify(this.props.data) || this.state.chartDisplay != nextState.chartDisplay

        //return ((nextProps.begin_date != this.props.begin_date) || (nextProps.end_date != this.props.end_date))
        //return true
    }


  
    componentDidUpdate() {
        this.createChart();
    }

    componentDidMount() {
        this.createChart();
    }



    createChart = () => {

        const {t} = this.props

        var data = this.props.data.map(r => {
            /*let diff = Math.abs(parseInt(r.deplacements) - parseInt(r.ouvertures))
            let dep = parseInt(r.deplacements)
            let ouv = parseInt(r.ouvertures)*/

            return {
                ...r,
                date: r.date*1000//r.date.toDate(),
                //date: r.mdate.toDate(),
                //bullet: (diff > dep / 3) || dep == 0 || ouv == 0 ? 'https://sts.amphitech.fr/img/error.svg' : ''
            }
        })

        am4core.options.queue = true;
        am4core.options.onlyShowOnViewport = true;
        am4core.useTheme(am4themes_kelly);


        var chart = am4core.create("chartdiv", am4charts.XYChart);

        

        chart.svgContainer.autoResize = false;

        var dateAxis = chart.xAxes.push(new am4charts.DateAxis());

        //dateAxis.groupData = true;

        /*dateAxis.min = this.props.begin_date.getTime();
        dateAxis.max = this.props.end_date.getTime();*/

        chart.exporting.menu = new am4core.ExportMenu();
        chart.legend = new am4charts.Legend();
        chart.language.locale = am4lang_fr_FR;
        
        dateAxis.dataFields.dateX = "date";

        dateAxis.baseInterval = {
            "timeUnit": "day",
            "count": 1
        };
        dateAxis.groupInterval = { timeUnit: "day", count: 1 };

        dateAxis.dateFormats.setKey("day", "dd MMMM YYYY");
        dateAxis.periodChangeDateFormats.setKey("day", "dd MMMM YYYY");

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.dataFields.category = t("lineChart.openings");


        chart.scrollbarX = new am4charts.XYChartScrollbar();
        chart.cursor = new am4charts.XYCursor();

        chart.scrollbarX.parent = chart.bottomAxesContainer;
        chart.scrollbarY = new am4core.Scrollbar();
        chart.scrollbarY.parent = chart.leftAxesContainer;

        chart.zoomOutButton.align = "left";
        chart.preloader.disabled = true;

        

        if (this.state.chartDisplay == 'stacked') {
            //dateAxis.groupData = true;

            valueAxis.title.text = t("lineChart.openings");

            var etages = []

            _.each(data, (d) => {
                //etages = etages.concat(Object.keys(_.omit(d, ['deplacements', 'ouvertures', 'date'])))
                //etages = etages.concat(Object.keys(d))
                etages = etages.concat(Object.keys(_.omit(d, ['deplacements', 'ouvertures', 'date'])))
            })


            etages = Array.from(new Set(etages))

            _.each(etages, (d) => {
                //this.createSeries(chart, d, d)
                var series = chart.series.push(new am4charts.ColumnSeries());
                series.name = d;
                series.dataFields.valueY = d;
                series.dataFields.dateX = "date";
                //series.sequencedInterpolation = true;

                series.stacked = true;

                chart.scrollbarX.series.push(series);

            })

            var ttext = ''

            _.each(etages, (d) => {
                ttext += "[font-size:10px][bold]" + d + " : {" + d + "}\n"
            });


            chart.series.getIndex(0).columns.template.tooltipText = ttext;  // Configure columns



        } else if (this.state.chartDisplay == 'normal') {
            // Create series
            var series = chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.valueY = "ouvertures";
            series.dataFields.dateX = "date";
            series.clustered = false;
            series.tooltipText = "Ouvertures : [bold]{valueY}[/]";

            series.name = 'ouvertures';

            series.columns.template.width = am4core.percent(80);
            //series.columns.template.height = am4core.percent(110);

            var series2 = chart.series.push(new am4charts.ColumnSeries());
            series2.dataFields.valueY = "deplacements";
            series2.dataFields.dateX = "date";
            series2.clustered = false;
            series2.columns.template.width = am4core.percent(30);
            //series2.columns.template.height = am4core.percent(70);

            series2.tooltip.getFillFromObject = false;


            series2.tooltip.background.fill = am4core.color("#ba03fc");

            series2.tooltipText = t("lineChart.moves")+" : [bold]{valueY}[/]";
            series2.name = 'deplacements';

            /*series2.columns.template.adapter.add("fill", function (fill, target) {
                return am4core.color("#ba03fc");
            });*/

            /*series2.columns.template.background.adapter.add("fill", function (fill, target) {
                return am4core.color("#ba03fc");
            });*/


            // Add cursor
            chart.cursor = new am4charts.XYCursor();
            chart.cursor.xAxis = dateAxis;
            //chart.cursor.snapToSeries = series;

            chart.scrollbarX.series.push(series);
            chart.scrollbarX.series.push(series2);

            valueAxis.title.text = t("lineChart.moves&openings");

            /*
            var bullet = series.bullets.push(new am4charts.Bullet());
            var image = bullet.createChild(am4core.Image);
            image.horizontalCenter = "middle";
            image.verticalCenter = "bottom";
            image.width = 15;
            image.height = 15;
            image.y = am4core.percent(100);
            image.propertyFields.href = "bullet";
            image.tooltipText = "Anomalie constatée";
            image.filters.push(new am4core.DropShadowFilter());*/

        }

        var indicator = false;

        function showIndicator() {
            if (indicator) {
                return
            }
        
            indicator = chart.tooltipContainer.createChild(am4core.Container);
            indicator.background.fill = am4core.color("#fff");
            indicator.background.fillOpacity = 1;
            indicator.width = am4core.percent(100);
            indicator.height = am4core.percent(100);
        
            var indicatorLabel = indicator.createChild(am4core.Label);
            indicatorLabel.text = "Chargement...";
            indicatorLabel.align = "center";
            indicatorLabel.valign = "middle";
            indicatorLabel.fontSize = 20;
            indicatorLabel.dy = 50;
            
            var hourglass = indicator.createChild(am4core.Image);
            hourglass.href = "https://s3-us-west-2.amazonaws.com/s.cdpn.io/t-160/hourglass.svg";
            hourglass.align = "center";
            hourglass.valign = "middle";
            hourglass.horizontalCenter = "middle";
            hourglass.verticalCenter = "middle";
            hourglass.scale = 0.7;
            
            
            indicator.hide(0);
            indicator.show();
            
    
            function hideIndicator() {

                if( !indicator ) {
                    return
                }

                indicator.dispose()
                
                /*
                indicator.hide(0);
                indicator.background.fillOpacity = 0;
                indicator.width = am4core.percent(0);
                indicator.height = am4core.percent(0);*/
                indicator = false
            }                        
    
            chart.events.on("ready", function(ev){
                hideIndicator();
            });

          
        }

        showIndicator()


        chart.data = data;

        this.chart = chart

    }




    handleOptionChange = (changeEvent) => {
        this.setState({
            chartDisplay: changeEvent.target.value
        }, () => {

            //this.createChart();

        });
    }

    render() {
        const {t} = this.props
        return (
            <div>



                <div style={{ width: '263px', margin: '0 auto' }}>
                    
                    {t('lineChart.display_moves_openings')} <input type="radio" value="normal" name="chartDisplay" onChange={this.handleOptionChange} checked={this.state.chartDisplay == 'normal'} /> <br />
                    {t('lineChart.open_details')} <input type="radio" value="stacked" name="chartDisplay" onChange={this.handleOptionChange} checked={this.state.chartDisplay == 'stacked'} />

                </div>

                {/* Bar line< input type="radio" value="lineBar" name="chartDisplay" onChange={this.handleOptionChange} />
               
                 3D <input type="radio" value="3D" name="chartDisplay" onChange={this.handleOptionChange} />*/}



                <div id="chartdiv" style={{ width: "100%", height: "450px" }} />



            </div>
        );
    }
}

export default LineChart;


function showLoadingIndicator({
    chart,
    onReady,
  }) {
    if (chart.preloader) {
      chart.preloader.disabled = true;
    }
  
    const eventTriggerType = chart._ready ? 'validated' : 'ready';
  
    function onChartReady(ev) {
      if (onReady) {
        onReady();
      }
      chart.events.off(eventTriggerType, onChartReady, this);
    }
    chart.events.on(eventTriggerType, onChartReady, this);
  }